<template>
  <InputNumber
    locale="locale-user"
    :use-grouping="!noGrouping"
    @input="updateModelValue"
    :modelValue="modelValue"
    :maxFractionDigits="parseInt(calcMaxDecimals())"
    :minFractionDigits="parseInt(calcMinDecimals())"
    unstyled
    :pt="{
      root: ({ state }) => ({
        class: [
          'block w-full bg-white dark:bg-slate-700',
          state.focused ? focusClass:'',
          transitionClass,
          borderClass
        ]
      }),
      input: {
        root: {
          class: [
            'w-full outline-0 bg-transparent',
            paddingClass,
            textClass
          ]
        }
      }
    }"
  />
</template>


<script>

import InputNumber from 'primevue/inputnumber';

export default {
  name: "RpmNumberInput",
  components: {
    InputNumber,
  },
  data() {
    return {
      focus: false,
    };
  },
  props: {
    modelValue: {
      default: null
    },
    decimals: {
      type: [Number, String],
      default: 0
    },
    minDecimals: {
      type: [Number, String],
      default: null
    },
    maxDecimals: {
      type: [Number, String],
      default: null
    },
    noGrouping: {
      type: Boolean,
      default: false
    },
    positive: {
      type: Boolean,
      default: false
    },
    negative: {
      type: Boolean,
      default: false
    },
    focusClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
  },
  methods: {
    updateModelValue(val) {
      this.$emit("update:modelValue", val.value);
    },
    calcMaxDecimals(){
      if(this.maxDecimals) return this.maxDecimals;
      return this.decimals;
    },
    calcMinDecimals(){
      if(this.minDecimals) return this.minDecimals;
      return this.decimals;
    }
  },
  watch: {
    modelValue(newer){
      if(this.positive){
        if(newer && !isNaN(newer) && newer < 0) this.$emit("update:modelValue", 0);
      }else if(this.negative){
        if(newer && !isNaN(newer) && newer > 0) this.$emit("update:modelValue", 0);
      }
    }
  },
};
</script>
